import React from "react"
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap"
// import errorMessages, {generalErrorMessage} from "../config/errorMessages"

const ErrorDialog = ({isOpen, toggle, notEligible, lang}) => {
  // const getErrorMessage = errorMessages.find((errorMessage) => errorMessage.apiError === message)?.message
  const generalErrorMessage = 'We are unable to process your request at the moment. Please try again later.'
  const NotEligibleContent = () => <>{lang.error.notEligible1} <a href="tel:+60321707300">03-2170 7300</a> {lang.error.notEligible2} <a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a></>

  return <>
    <Modal isOpen={isOpen} toggle={toggle}  className="contact">
      <ModalHeader toggle={toggle}>{lang.error.errorOccured}</ModalHeader>
      <ModalBody>
        {notEligible ? <NotEligibleContent /> : generalErrorMessage}
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => toggle()}>Ok</Button>
      </ModalFooter>
    </Modal>
  </>
}

export default ErrorDialog